import { BaseModel, type RelationConfig } from './base';

import { CustomField } from './customField';
import { ProductCategory } from './productCategory';
import { ProductInventoryTransaction } from './productInventoryTransaction';
import { Tax } from './tax';

// Helper Classes

export class ProductCategorised extends BaseModel {
  productCategory!: ProductCategory | null;
  products!: Product[];

  static override relations(): RelationConfig {
    return {
      productCategory: { type: ProductCategory },
      products: { type: Product },
    };
  }
}

export class ProductOptions extends BaseModel {
  productCategories!: ProductCategory[];
  taxes!: Tax[];

  static override relations(): RelationConfig {
    return {
      productCategories: { type: ProductCategory },
      taxes: { type: Tax },
    };
  }
}

// Main Model

export class Product extends BaseModel {
  static modelName(): string {
    return 'product'
  }

  idProduct!: number;
  name!: string;
  listOrder?: number;
  price!: number;
  hasImage!: boolean;
  images!: Record<string, string> | null;
  imageUrls!: Record<string, string> | null;
  category!: ProductCategory | null;
  options!: ProductOptions | null;
  customFields!: CustomField[];
  inventoryTransactions!: ProductInventoryTransaction[];

  static override relations(): RelationConfig {
    return {
      category: { type: ProductCategory },
      options: { type: ProductOptions },
      customFields: { type: CustomField },
      inventoryTransactions: { type: ProductInventoryTransaction },
    };
  }

  override objectID(): string | null {
    return Number(this.idProduct) > 0 ? this.idProduct.toString() : null;
  }

  matchesQuery(query: string): boolean {
    const lowerQuery = query.toLowerCase();
    return !!this.name && this.name.toLowerCase().includes(lowerQuery);
  }

  get image(): string | null {
    if (this.hasImage) {
      return this.images?.square || this.imageUrls?.square || null;
    }
    return null;
  }

  get initials(): string {
    return this.name?.charAt(0).toUpperCase() ?? '';
  }
}
